<div class="contact-section">
  <div class="container">
    <h2 class="section-heading text-center">Contact Us</h2>

    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="contact-card">
          <div class="contact-info">
            <h5> Address</h5>
            <p>
             4th Floor,Majestic Signia,405,Plot No.A-27,Block A, Industrial Area, Sector 62,Noida,Uttar Pradesh 201309
            </p>
          </div>

          <div class="contact-info">
            <h5> Email</h5>
            <p>support@zenithguard.in</p>
          </div>

          <div class="contact-info">
            <h5> Phone</h5>
            <p>+91 8076949229</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
